import { Stack } from '@mui/material';
import { Outlet } from '@tanstack/react-router';
import { SecurityPage } from '@/components/Security/SecurityPage';

export const SecurityIndexComponent = () => (
  <SecurityPage>
    <Stack sx={{ gap: 2, mt: 4 }}>
      <Outlet />
    </Stack>
  </SecurityPage>
);
